import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import SVGTitle from "./SVGTitle";

function Activities() {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div
      className="activities py-5"
      id="activities"
      style={{ borderBottom: "1px solid #ccc", overflow: "hidden" }}
      dir={dir}
    >
      <Helmet>
        <title>{t("activities.pageTitle")}</title>
        <meta name="description" content={t("activities.pageDescription")} />
        <meta name="keywords" content={t("activities.pageKeywords")} />

        <meta property="og:title" content={t("activities.ogTitle")} />
        <meta
          property="og:description"
          content={t("activities.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://slimsmile.ps/images/activities-cover.jpg"
        />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content="ar_AR" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: t("activities.faq", { returnObjects: true }),
          })}
        </script>
      </Helmet>

      <div className="container">
        <div className="head text-center">
          <h2 className="mb-4 fs-1 fw-bolder">{t("activities.heading")}</h2>
          <SVGTitle />
        </div>

        <div className="row flex-lg-row flex-md-row flex-column-reverse">
          <motion.div
            className={`col-lg-6 col-md-12 `}
            style={{ letterSpacing: "1.2px", lineHeight: "30px" }}
            initial={{ opacity: 0, x: dir === "rtl" ? -100 : 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            {t("activities.paragraphs", { returnObjects: true }).map(
              (para, i) => (
                <p key={i}>{para}</p>
              )
            )}
          </motion.div>
          <motion.div
            className={`video col-lg-6 col-md-12 `}
            initial={{ opacity: 0, x: dir === "rtl" ? 100 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <video
              className="rounded"
              muted
              autoPlay
              loop
              controls
              playsInline
              preload="metadata"
              style={{ width: "100%", maxHeight: "400px", objectFit: "cover" }}
            >
              <source src="/assets/video/active-video.mp4" type="video/mp4" />
              {t("activities.videoFallback")}
            </video>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Activities;
